(function () {
  if (window.__AG_PB_DOCTORS_INIT__) return;
  window.__AG_PB_DOCTORS_INIT__ = true;

  /* Clones keep the slide class, so this returns the full strip in loop mode. */
  function getSlides(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.ag-pb-doctors__track > .ag-pb-doctors__slide'));
  }

  /* Loop controller keyed by track — the positions helpers only receive the track. */
  var loops = new WeakMap();

  function getLoop(track) {
    return loops.get(track) || null;
  }

  function getTrackGap(track) {
    var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap);
    return isNaN(gap) ? 0 : gap;
  }

  function getTrackPadLeft(track) {
    return parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
  }

  function parseCssPx(value) {
    if (!value || value === 'none') return 0;
    var n = parseFloat(value);
    return isNaN(n) ? 0 : n;
  }

  function getContentInlinePad(root, isDesktop) {
    var measure = root.querySelector('.ag-pb-doctors__max-measure');
    var intro = root.querySelector('.ag-pb-doctors__intro');
    var padEl = measure || intro;
    if (padEl) {
      var style = window.getComputedStyle(padEl);
      var padLeft = parseFloat(style.paddingLeft);
      var padRight = parseFloat(style.paddingRight);
      if (!isNaN(padLeft) && !isNaN(padRight)) {
        return { left: padLeft, right: padRight };
      }
    }
    var fallback = isDesktop ? 150 : 16;
    return { left: fallback, right: fallback };
  }

  function syncAlignInset(root) {
    var section = root.closest('.shopify-section--ag-page-blocks') || root.closest('.ag-page-blocks');
    /* clientWidth, not innerWidth: it excludes the classic scrollbar, matching the
       coordinate space getBoundingClientRect() reports the insets in. Feeds the
       full-bleed viewport width so the track can't drift scrollbar/2 to the left. */
    var viewport = document.documentElement.clientWidth;
    var isDesktop = window.matchMedia('(min-width: 741px)').matches;
    var pad = getContentInlinePad(root, isDesktop);
    var left = null;
    var right = null;

    /* Prefer live content column (same as reviews) when present */
    if (section) {
      var cards = section.querySelector('.ag-pb-benefits__cards');
      if (cards) {
        var cardsRect = cards.getBoundingClientRect();
        if (cardsRect.width > 0 && isFinite(cardsRect.left) && isFinite(cardsRect.right)) {
          left = cardsRect.left;
          right = cardsRect.right;
        }
      }

      if (left == null || right == null) {
        var shell = section.querySelector('.ag-pb-shell__inner');
        if (shell) {
          var shellRect = shell.getBoundingClientRect();
          var shellStyle = window.getComputedStyle(shell);
          var shellPadL = parseFloat(shellStyle.paddingLeft) || 0;
          var shellPadR = parseFloat(shellStyle.paddingRight) || 0;
          if (shellRect.width > 0 && isFinite(shellRect.left) && isFinite(shellRect.right)) {
            left = shellRect.left + shellPadL;
            right = shellRect.right - shellPadR;
          }
        }
      }
    }

    /*
      Probe = content-max box + shell/gutter pad.
      Read padded edges (not outer box) so cards match intro / section column.
      Do NOT treat near-full-width max (default 1440) as “no max” → that ignored content column.
    */
    if (left == null || right == null) {
      var measure = root.querySelector('.ag-pb-doctors__max-measure');
      if (measure) {
        var rect = measure.getBoundingClientRect();
        if (rect.width > 0 && isFinite(rect.left) && isFinite(rect.right)) {
          var mStyle = window.getComputedStyle(measure);
          var padL = parseFloat(mStyle.paddingLeft);
          var padR = parseFloat(mStyle.paddingRight);
          if (isNaN(padL)) padL = pad.left;
          if (isNaN(padR)) padR = pad.right;
          left = rect.left + padL;
          right = rect.right - padR;
        }
      }
    }

    if ((left == null || right == null) && section) {
      var sectionStyle = window.getComputedStyle(section);
      var maxRaw = isDesktop
        ? sectionStyle.getPropertyValue('--ag-page-blocks-content-max-desktop')
        : sectionStyle.getPropertyValue('--ag-page-blocks-content-max-mobile');
      var maxWidth = parseCssPx(maxRaw);

      if (maxWidth > 0 && maxWidth < viewport) {
        var side = (viewport - maxWidth) / 2;
        left = side + pad.left;
        right = viewport - side - pad.right;
      } else {
        left = pad.left;
        right = viewport - pad.right;
      }
    }

    if (left == null || !isFinite(left)) {
      left = pad.left;
      right = viewport - pad.right;
    }

    root.style.setProperty('--ag-pb-doctors-vw', viewport + 'px');
    root.style.setProperty('--ag-pb-doctors-align-inset', Math.max(0, Math.round(left)) + 'px');
    root.style.setProperty(
      '--ag-pb-doctors-pad-right',
      Math.max(0, Math.round(viewport - right)) + 'px'
    );
  }

  /* Figma 10063:1509 — the desktop media is `aspect-[500/360] h-full`. */
  var MEDIA_RATIO = 500 / 360;

  /*
    CSS can't derive that width on its own: inside the track the slide needs an
    intrinsic width, and a max-content pass has no definite height to transfer the
    ratio from (the cards then overflow their slides and overlap). The copy panel is
    a fixed 500px, so its height doesn't depend on the media width — measure the
    tallest one (they all stretch to the row) and publish the width from it.
  */
  function syncMediaWidth(root) {
    if (!window.matchMedia('(min-width: 741px)').matches) {
      root.style.removeProperty('--ag-pb-doctors-media-w');
      return;
    }

    var panels = root.querySelectorAll('.ag-pb-doctors-card__panel');
    var tallest = 0;

    for (var i = 0; i < panels.length; i++) {
      var height = panels[i].getBoundingClientRect().height;
      if (height > tallest) tallest = height;
    }

    if (tallest <= 0) return;

    root.style.setProperty('--ag-pb-doctors-media-w', Math.round(tallest * MEDIA_RATIO) + 'px');
  }

  function getMaxScroll(track) {
    return Math.max(0, track.scrollWidth - track.clientWidth);
  }

  function getScrollStep(track, slides) {
    if (!track || slides.length === 0) return 0;

    var gap = getTrackGap(track);
    var slideWidth = slides[0].getBoundingClientRect().width;
    var step = slideWidth + gap;

    return step > 0 ? step : 0;
  }

  /**
   * One scroll stop per slide (left-align each card).
   * Last stop uses maxScroll so the final card can sit flush to the right edge.
   * Avoids skipping the middle card when maxScroll is only ~1 step (2 dots for 3 slides).
   */
  function getPageScrollPositions(track, slides) {
    var maxScroll = getMaxScroll(track);

    /*
      Looping: one stop per slide with no maxScroll clamp and no right-flush final stop.
      Both of those encode "there is an end", which would fight the seamless wrap.
    */
    if (getLoop(track) && slides && slides.length) {
      var loopOrigin = slides[0].offsetLeft;
      return slides.map(function (slide) {
        return Math.round(slide.offsetLeft - loopOrigin);
      });
    }

    if (maxScroll <= 1) return [0];
    if (!slides || slides.length === 0) return [0];

    var origin = slides[0].offsetLeft;
    var positions = [0];

    for (var i = 1; i < slides.length; i++) {
      var pos = Math.round(slides[i].offsetLeft - origin);
      pos = Math.max(0, Math.min(pos, maxScroll));
      if (Math.abs(positions[positions.length - 1] - pos) > 2) {
        positions.push(pos);
      }
    }

    /* Final stop = true end (right flush). Keep one stop per slide — no extra dot. */
    if (positions.length > 1) {
      positions[positions.length - 1] = maxScroll;
    } else if (maxScroll > 1) {
      positions.push(maxScroll);
    }

    return positions;
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function updateActiveDot(root, pageIndex) {
    var track = root.querySelector('.js-ag-pb-doctors-track');
    var loop = track ? getLoop(track) : null;
    var active = loop ? loop.realIndex(pageIndex) : pageIndex;

    var dots = root.querySelectorAll('.ag-pb-doctors__dot');
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === active);
      dot.setAttribute('aria-current', i === active ? 'true' : 'false');
    });
  }

  function waitForScrollEnd(track, callback) {
    var done = false;

    function finish() {
      if (done) return;
      done = true;
      track.removeEventListener('scrollend', finish);
      callback();
    }

    if ('onscrollend' in track) {
      track.addEventListener('scrollend', finish, { once: true });
      window.setTimeout(finish, 700);
      return;
    }

    window.setTimeout(finish, 450);
  }

  function scrollToOffset(root, track, targetScroll, pageIndex, velocityX) {
    if (!track) return;

    targetScroll = Math.max(0, Math.min(targetScroll, getMaxScroll(track)));
    track.classList.add('is-navigating');

    function finishNav() {
      track.classList.remove('is-navigating');
      updateActiveDot(root, pageIndex);
      /* Re-centre on the middle set once movement stops, never mid-gesture. */
      var loop = getLoop(track);
      if (loop) loop.normalize();
    }

    if (prefersReducedMotion()) {
      track.scrollLeft = targetScroll;
      finishNav();
      return;
    }

    /* Touch releases carry the flick speed into the settle so it coasts instead of
       running the browser's fixed smooth-scroll curve. Dots/arrows keep that curve. */
    if (typeof velocityX === 'number' && window.AgPbSwipe && window.AgPbSwipe.glide) {
      window.AgPbSwipe.glide(track, targetScroll, { velocityX: velocityX, onDone: finishNav });
      return;
    }

    track.scrollTo({
      left: targetScroll,
      behavior: 'smooth'
    });

    waitForScrollEnd(track, finishNav);
  }

  function getActivePageIndex(track, slides) {
    if (!track || slides.length === 0) return 0;

    var positions = getPageScrollPositions(track, slides);
    if (positions.length <= 1) return 0;

    var scrollLeft = track.scrollLeft;
    var maxScroll = getMaxScroll(track);

    /* The right-edge shortcut only makes sense for a finite track. */
    if (!getLoop(track) && scrollLeft >= maxScroll - 2) return positions.length - 1;

    var closest = 0;
    var closestDistance = Infinity;

    positions.forEach(function (position, index) {
      var distance = Math.abs(scrollLeft - position);
      if (distance < closestDistance) {
        closestDistance = distance;
        closest = index;
      }
    });

    return closest;
  }

  function syncActiveFromScroll(root, track, slides) {
    if (!track || slides.length === 0 || track.classList.contains('is-navigating')) return;
    updateActiveDot(root, getActivePageIndex(track, slides));
  }

  function resetTrackPosition(track) {
    track.classList.add('is-navigating');
    /* Looping: park on the middle set, which renders identically to scrollLeft 0. */
    var loop = getLoop(track);
    if (loop) loop.reset();
    else track.scrollLeft = 0;
    track.classList.remove('is-navigating');
  }

  function buildDots(root, track, slides) {
    var dotsWrap = root.querySelector('.js-ag-pb-doctors-dots');
    if (!dotsWrap) return;

    dotsWrap.innerHTML = '';

    var positions = getPageScrollPositions(track, slides);

    if (positions.length <= 1) {
      dotsWrap.hidden = true;
      dotsWrap.setAttribute('aria-hidden', 'true');
      return;
    }

    dotsWrap.hidden = false;
    dotsWrap.removeAttribute('aria-hidden');
    dotsWrap.setAttribute('role', 'tablist');
    dotsWrap.setAttribute('aria-label', 'Doctor slides');

    /* Looping: one dot per real slide, not one per stop across all three copies. */
    var loop = getLoop(track);
    var dotCount = loop ? loop.realCount : positions.length;

    for (var i = 0; i < dotCount; i++) {
      (function (pageIndex) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ag-pb-doctors__dot' + (pageIndex === 0 ? ' is-active' : '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to doctor ' + (pageIndex + 1));
        dot.setAttribute('aria-current', pageIndex === 0 ? 'true' : 'false');
        dot.addEventListener('click', function () {
          var nextSlides = getSlides(root);
          var nextPositions = getPageScrollPositions(track, nextSlides);
          var index = pageIndex;

          /* Jump to whichever copy of that slide is nearest, so the dots never send
             the track on a long scroll back through the whole set. */
          if (loop) {
            var here = getActivePageIndex(track, nextSlides);
            var offset = loop.realIndex(pageIndex) - loop.realIndex(here);
            var half = loop.realCount / 2;
            if (offset > half) offset -= loop.realCount;
            if (offset < -half) offset += loop.realCount;
            index = Math.max(0, Math.min(here + offset, nextPositions.length - 1));
          }

          var target = nextPositions[index];
          if (typeof target !== 'number') {
            target = index >= nextPositions.length - 1
              ? getMaxScroll(track)
              : nextPositions[nextPositions.length - 1];
          }
          scrollToOffset(root, track, target, Math.min(index, nextPositions.length - 1));
        });
        dotsWrap.appendChild(dot);
      })(i);
    }
  }

  /**
   * Pick settle page from drag intent.
   * Pointer right (deltaX > 0) → scroll back (prev).
   * Pointer left (deltaX < 0) → scroll forward (next).
   */
  function getDragSettlePageIndex(track, slides, startPageIndex, deltaX, velocityX) {
    var positions = getPageScrollPositions(track, slides);
    if (positions.length <= 1) return 0;

    var last = positions.length - 1;
    var startIndex = Math.max(0, Math.min(startPageIndex, last));
    var step = getScrollStep(track, slides) || 1;
    var distanceThreshold = step * 0.18;
    var velocityThreshold = 0.45; /* px/ms */
    var wentForward = deltaX < -distanceThreshold || velocityX < -velocityThreshold;
    var wentBackward = deltaX > distanceThreshold || velocityX > velocityThreshold;

    if (wentForward) return Math.min(startIndex + 1, last);
    if (wentBackward) return Math.max(startIndex - 1, 0);

    return getActivePageIndex(track, slides);
  }

  function settleToPage(root, track, pageIndex, velocityX) {
    var slides = getSlides(root);
    var positions = getPageScrollPositions(track, slides);
    if (positions.length === 0) return;

    var index = Math.max(0, Math.min(pageIndex, positions.length - 1));
    scrollToOffset(root, track, positions[index], index, velocityX);
  }

  function initDragScroll(track, root) {
    if (track.dataset.agPbDoctorsDragReady === 'true') return;
    track.dataset.agPbDoctorsDragReady = 'true';

    var isDragging = false;
    var pointerId = null;
    var startX = 0;
    var startScrollLeft = 0;
    var startPageIndex = 0;
    var startTime = 0;
    var lastX = 0;
    var lastTime = 0;
    var velocityX = 0;
    var dragged = false;

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (track.classList.contains('is-navigating')) return;

      isDragging = true;
      dragged = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      lastX = event.clientX;
      startScrollLeft = track.scrollLeft;
      startPageIndex = getActivePageIndex(track, getSlides(root));
      startTime = Date.now();
      lastTime = startTime;
      velocityX = 0;
      track.classList.add('is-dragging');

      if (track.setPointerCapture) {
        track.setPointerCapture(event.pointerId);
      }
    });

    track.addEventListener('pointermove', function (event) {
      if (!isDragging || event.pointerId !== pointerId) return;

      var now = Date.now();
      var deltaX = event.clientX - startX;
      var frameDt = now - lastTime;

      if (frameDt > 0) {
        velocityX = (event.clientX - lastX) / frameDt;
      }

      lastX = event.clientX;
      lastTime = now;

      if (Math.abs(deltaX) > 4) dragged = true;

      track.scrollLeft = Math.max(0, Math.min(startScrollLeft - deltaX, getMaxScroll(track)));
      event.preventDefault();
    });

    function endDrag(event) {
      if (!isDragging) return;
      if (event && pointerId != null && event.pointerId !== pointerId) return;

      var deltaX = (event && typeof event.clientX === 'number' ? event.clientX : lastX) - startX;
      var elapsed = Math.max(Date.now() - startTime, 1);

      /* Blend last frame velocity with overall swipe velocity */
      var overallVelocity = deltaX / elapsed;
      var settleVelocity = Math.abs(velocityX) > Math.abs(overallVelocity) ? velocityX : overallVelocity;

      isDragging = false;
      pointerId = null;

      if (track.releasePointerCapture && event && track.hasPointerCapture(event.pointerId)) {
        track.releasePointerCapture(event.pointerId);
      }

      if (!dragged) {
        track.classList.remove('is-dragging');
        return;
      }

      track.dataset.agPbDoctorsSuppressClick = 'true';
      window.setTimeout(function () {
        delete track.dataset.agPbDoctorsSuppressClick;
      }, 0);

      /* Keep snap/interaction lock until settle scroll finishes */
      track.classList.add('is-navigating');
      track.classList.remove('is-dragging');

      var settleIndex = getDragSettlePageIndex(
        track,
        getSlides(root),
        startPageIndex,
        deltaX,
        settleVelocity
      );

      settleToPage(root, track, settleIndex);
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('lostpointercapture', function (event) {
      if (isDragging) endDrag(event);
    });

    track.addEventListener('click', function (event) {
      if (track.dataset.agPbDoctorsSuppressClick === 'true') {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);

    /* Touch native scroll: settle to nearest page when momentum ends */
    track.addEventListener('scrollend', function () {
      /* Continuous scroll rests wherever it paused — don't snap it to a stop. */
      if (track.__agPbAutoScroll) return;
      if (track.classList.contains('is-dragging') || track.classList.contains('is-navigating')) return;
      if (track.dataset.agPbDoctorsDragReady !== 'true') return;

      var slides = getSlides(root);
      var positions = getPageScrollPositions(track, slides);
      if (positions.length <= 1) return;

      var index = getActivePageIndex(track, slides);
      var target = positions[index];
      if (Math.abs(track.scrollLeft - target) < 2) {
        updateActiveDot(root, index);
        return;
      }

      settleToPage(root, track, index);
    });
  }

  function refreshLayout(root, track) {
    syncMediaWidth(root);
    syncAlignInset(root);
    var slides = getSlides(root);
    buildDots(root, track, slides);
    syncActiveFromScroll(root, track, slides);
  }

  function initBlock(root) {
    if (root.dataset.agPbDoctorsReady === 'true') return;

    var track = root.querySelector('.js-ag-pb-doctors-track');
    var slides = getSlides(root);

    if (!track || slides.length === 0) return;

    root.dataset.agPbDoctorsReady = 'true';

    /* Clone the set before anything measures, so stops and dots see the real strip. */
    if (root.dataset.agPbLoop === 'true' && window.AgPbSwipe && window.AgPbSwipe.enableLoop) {
      var loop = window.AgPbSwipe.enableLoop(track, { slideSelector: '.ag-pb-doctors__slide' });
      if (loop) loops.set(track, loop);
    }

    syncMediaWidth(root);
    syncAlignInset(root);
    resetTrackPosition(track);
    slides = getSlides(root);
    buildDots(root, track, slides);
    initDragScroll(track, root);
    updateActiveDot(root, 0);

    if (root.dataset.agPbAutoscroll === 'true' && window.AgPbSwipe && window.AgPbSwipe.autoScroll) {
      window.AgPbSwipe.autoScroll(track, { speed: parseFloat(root.dataset.agPbAutoscrollSpeed) });
    }

    /* Touch horizontal is JS-driven (CSS drops native h-scroll on coarse pointers).
       Settle on drag intent via the same distance/velocity rule the mouse drag uses —
       nearest-slide alone would force a >50% swipe to advance. */
    if (window.AgPbSwipe) {
      var swipeStartPage = 0;
      window.AgPbSwipe.bind(track, {
        onStart: function () {
          swipeStartPage = getActivePageIndex(track, getSlides(root));
        },
        onSettle: function (drag) {
          settleToPage(
            root,
            track,
            getDragSettlePageIndex(track, getSlides(root), swipeStartPage, drag.deltaX, drag.velocityX),
            drag.velocityX
          );
        }
      });
    }

    requestAnimationFrame(function () {
      syncMediaWidth(root);
      syncAlignInset(root);
      requestAnimationFrame(function () {
        resetTrackPosition(track);
        buildDots(root, track, getSlides(root));
        updateActiveDot(root, 0);
      });
    });

    var scrollRaf = false;
    track.addEventListener('scroll', function () {
      if (scrollRaf) return;
      scrollRaf = true;
      requestAnimationFrame(function () {
        syncActiveFromScroll(root, track, getSlides(root));
        scrollRaf = false;
      });
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        refreshLayout(root, track);
      }, 200);
    });
  }

  function initAll() {
    document.querySelectorAll('.js-ag-pb-doctors').forEach(initBlock);
  }

  function resetAll() {
    document.querySelectorAll('.js-ag-pb-doctors').forEach(function (root) {
      delete root.dataset.agPbDoctorsReady;
      var track = root.querySelector('.js-ag-pb-doctors-track');
      if (track) delete track.dataset.agPbDoctorsDragReady;
    });
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', resetAll);
  document.addEventListener('shopify:block:select', resetAll);
})();
